module.exports = __webpack_public_path__ + "img/cloud01.1b5c0a8d.png";